// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v5.5.1-jSoAt0XH0RmA5q5lMsh2/mode=imports,min/optimized/keen-slider.js'

class MobileMenuPopularCollections extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const barWidth = 200 / this.els.slide.elements.length
    this.els.progress.element.style.setProperty('--bar-width', `${barWidth}%`)

    if (this.els.slide.elements.length < 3) {
      this.els.progress.element.setAttribute('disabled', true)
      this.els.slides.element.classList.remove('car-Carousel_Slides')
      this.els.arrows.element.setAttribute('disabled', true)
    } else {
      this.carousel = this.initialiseCarousel()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.progressSwitch.bind(this))

    this.triggerMouseUpEvent = this.triggerMouseUpEvent.bind(this)
    this.listeners.add(this, 'contextmenu', this.triggerMouseUpEvent)

    this.listeners.add(this, 'mousedown', event => {
      if (event.target.closest('select')) {
        this.triggerMouseUpEvent(event)
      }
    })
  }

  triggerMouseUpEvent (event) {
    const mouseUpEvent = new MouseEvent('mouseup', { bubbles: true })
    event.target.dispatchEvent(mouseUpEvent)
  }

  progressSwitch () {
    const barWidth = 200 / this.els.slide.elements.length
    this.els.progress.element.style.setProperty('--bar-width', `${barWidth}%`)
  }

  initialiseCarousel () {
    if (this.carousel) return this.carousel

    return new KeenSlider(this.els.slides.element, {
      duration: 1000,
      loop: false,
      mode: 'snap',
      slidesPerView: 2,
      slides: '.car-Carousel_Slide',
      spacing: 20,
      move: instance => {
        if (this.els.progress.element) {
          const progressTrack = instance.details().progressTrack
          const movementPercentage = (progressTrack >= 0.9 ? 0 : progressTrack) * 100
          this.els.progress.element.style.setProperty('--progress', `${movementPercentage}%`)
        }
      },
      slideChanged: instance => {
        if (this.els.next.element) {
          const currentSlide = instance.details().absoluteSlide
          const slidesPerView = instance.details().slidesPerView
          const carouselSize = instance.details().size

          if (currentSlide === 0) {
            this.els.previous.element.setAttribute('disabled', null)
          } else {
            this.els.previous.element.removeAttribute('disabled')
          }

          if (currentSlide + slidesPerView >= carouselSize) {
            this.els.next.element.setAttribute('disabled', null)
          } else {
            this.els.next.element.removeAttribute('disabled')
          }
        }
      },
      created: instance => {
        this.setAttribute('data-initialised', true)

        if (this.nextEl) {
          this.nextEl.addEventListener('click', () => {
            instance.next()
          })
        }

        if (this.previousEl) {
          this.previousEl.addEventListener('click', () => {
            instance.prev()
          })
        }
      },
    })
  }

  get nextEl () {
    return this.els.next && this.els.next.element ? this.els.next.element : null
  }

  get previousEl () {
    return this.els.previous && this.els.previous.element ? this.els.previous.element : null
  }
}

if (!customElements.get('mobile-menu-popular-collections')) {
  customElements.define(
    'mobile-menu-popular-collections',
    MobileMenuPopularCollections,
  )
}
